import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { fromEvent } from 'file-selector';

import { uploadFiles } from '../actions/files';
import { checkStorageLimit } from '../utils/file-upload';

export default class DropPanel extends PureComponent {
    static propTypes = {
        projectId: PropTypes.string,
        taskId: PropTypes.string,
        docId: PropTypes.string,
        single: PropTypes.bool,
        upload: PropTypes.bool,
        provideController: PropTypes.func,
        onChange: PropTypes.func,
        onUpload: PropTypes.func
    };

    static defaultProps = {
        children: <span className="drop-panel-content"><i className="icon ion ion-android-attach" />Drop your files to upload</span>,
        className: 'drop-panel-default'
    }

    constructor(props) {
        super(props);

        this.state = {
            docDragOver: false,
            dragOver: false
        };

        this.handleDragenter = this.handleDragenter.bind(this);
        this.handleDragover = this.handleDragover.bind(this);
        this.handleDragleave = this.handleDragleave.bind(this);
        this.handleDocDragenter = this.handleDocDragenter.bind(this);
        this.handleDocDragover = this.handleDocDragover.bind(this);
        this.handleDocDragleave = this.handleDocDragleave.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
    }

    handleDragenter(event) {
        if (!this.hasFilesInEvent(event)) {
            return;
        }

        event.preventDefault();

        this.setState({
            dragOver: true
        });
    }

    handleDragover(event) {
        if (!this.hasFilesInEvent(event)) {
            return;
        }

        event.preventDefault();

        this.setState({
            dragOver: true
        });
    }

    handleDragleave(event) {
        if (event.target.type === 'file') {
            return;
        }

        this.setState({
            dragOver: false
        });
    }

    handleDocDragenter(event) {
        if (!this.hasFilesInEvent(event)) {
            return;
        }

        event.preventDefault();

        this.setState({
            docDragOver: true
        });
    }

    handleDocDragover(event) {
        if (!this.hasFilesInEvent(event)) {
            return;
        }

        event.preventDefault();

        this.setState({
            docDragOver: true
        });
    }

    handleDocDragleave(event) {
        this.setState({
            docDragOver: false
        });
    }

    async handleDrop(event) {
        this.setState({
            dragOver: false,
            docDragOver: false
        });

        if (!(event.target === this.element || event.target.parentNode === this.element)) {
            return;
        }

        event.preventDefault();

        const files = await this.getDroppedFiles(event);

        this.processFiles(files);
    }

    handleChange = event => {
        this.processFiles(this.getSelectedFiles(event));

        this.fileElement.value = '';
    }

    processFiles(files) {
        checkStorageLimit(files.reduce((size, file) => file.size + size, 0))
            .then(() => {
                this.props.onChange && this.props.onChange(files);

                if (!this.props.upload) {
                    return;
                }

                uploadFiles(files, {
                    project: this.props.projectId,
                    task: this.props.taskId,
                    doc: this.props.docId
                }).then(this.props.onUpload);
            });

    }

    getSelectedFiles(event) {
        return Array.prototype.slice.call(this.fileElement.files, 0);
    }

    async getDroppedFiles(event) {
        const files = await fromEvent(event);

        return files;
    }

    hasFilesInEvent(event) {
        return Array.from(event.dataTransfer.types).includes('Files');
    }

    bind() {
        this.element.addEventListener('dragenter', this.handleDragenter, false);
        this.element.addEventListener('dragover', this.handleDragover, false);
        this.element.addEventListener('dragleave', this.handleDragleave, false);
        document.addEventListener('dragenter', this.handleDocDragenter, false);
        document.addEventListener('dragover', this.handleDocDragover, false);
        document.addEventListener('dragleave', this.handleDocDragleave, false);
        document.addEventListener('drop', this.handleDrop, false);
    }

    unbind() {
        this.element.removeEventListener('dragenter', this.handleDragenter, false);
        this.element.removeEventListener('dragover', this.handleDragover, false);
        this.element.removeEventListener('dragleave', this.handleDragleave, false);
        document.removeEventListener('dragenter', this.handleDocDragenter, false);
        document.removeEventListener('dragover', this.handleDocDragover, false);
        document.removeEventListener('dragleave', this.handleDocDragleave, false);
        document.removeEventListener('drop', this.handleDrop, false);
    }

    componentDidMount() {
        this.bind();
    }

    componentWillUnmount() {
        this.unbind();
    }

    render() {
        return (
            <div className={'drop-panel ' + this.props.className + (this.state.docDragOver ? ' doc-over' : '') + (this.state.dragOver ? ' over' : '')} ref={el => this.element = el} onClick={this.disabled ? this.showMaintenance : null}>
                <div className="drop-panel-body">
                    {this.props.children}
                </div>

                <input multiple={!this.props.single} style={this.disabled ? {display: 'none'} : null} type="file" ref={element => this.fileElement = element} onChange={this.handleChange} />
            </div>
        )
    }
}